import React, { useState } from 'react';

import { LeatherBox } from '@/view/ui/common/NineSliceBox';
import { useGlobalStore } from '@/store/useGlobalStore';
import { GameScene } from '@/core/types/global.types';
import { useLingui } from '@lingui/react/macro';

export const PauseMenu = ({ onClose }: {onClose?: () => void}) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const globalStore = useGlobalStore();
  const { t } = useLingui();
  const handleAction = (action: () => void) => {
    if (isProcessing) return;
    setIsProcessing(true);
    
    action();
    
    setTimeout(() => setIsProcessing(false), 300);
  };

  return (
    <div className="relative pointer-events-auto" onClick={(e) => e.stopPropagation()}>
    <LeatherBox width={400} height={250} padding={50}>
      <div className="flex flex-col gap-3 w-56 mx-auto">
        
        <button 
          disabled={isProcessing}
          className="bb-btn"
          onClick={() => handleAction(() => {onClose?.()})}
        >
          {t`Resume`}
        </button>

        <button 
          disabled={isProcessing}
          className="bb-btn"
          onClick={() => handleAction(() => {
            
            globalStore.changeScene(GameScene.BATTLE);
            
          })}
        >
          {t`Restart Battle`}
        </button>

        <button 
          disabled={isProcessing}
          className="bb-btn"
          onClick={() => handleAction(() => {
            globalStore.setScene(GameScene.WORLD);
            // globalStore.changeScene(GameScene.WORLD);
          })}
        >
          {t`Main Menu`}
        </button>

      </div>
    </LeatherBox>
    </div>
  );
};